import Member from "./index.vue";
export default {
  install: function install(Vue, store) {
    var pluginOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var Instance = Vue.extend(Member);
    var member = null;

    function $memberShow() {
      return new Promise(function (resolve) {
        if (!member) {
          member = new Instance({
            store: store
          });
          member.$mount();
        }

        document.querySelector(pluginOptions.container || 'body').appendChild(member.$el);
        member.showPoup();
        resolve();
      });
    }

    $memberShow.hide = function () {
      if (member) {
        member.closePoup();
      }
    };

    Vue.memberShow = Vue.prototype.$memberShow = $memberShow;
  }
};